module.exports = __webpack_public_path__ + "b6866d0f6ee0b9199e0f339c8f5fc709.png";